<div class="p-7 w-[400px] max-w-[90vw]">
  <!-- Header -->
  <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] m-0 mb-2">Export Filters</p>
  <p class="text-sm text-[var(--base-text-alt-dark)] leading-relaxed">Select filters to apply to your export</p>

  <!-- Farm Select -->
  <div class="mb-4">
    <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark,#49454F)] uppercase tracking-wide mb-1.5">Farm</label>
    <select multiple [(ngModel)]="selectedFarms" (change)="onFarmSelectionChange(selectedFarms)"
      class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border,#E8E8EC)] rounded-lg text-[13px] font-medium bg-white outline-none focus:border-[var(--primary-dark,#E2703A)] transition-all h-[38px] overflow-hidden appearance-none cursor-pointer"
      style="display:none">
    </select>
    <div class="relative">
      <div (click)="showFarmDropdown = !showFarmDropdown; $event.stopPropagation()"
        class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border,#E8E8EC)] rounded-lg text-[13px] font-medium bg-white cursor-pointer flex items-center justify-between hover:border-[var(--primary-dark,#E2703A)] transition-all">
        <span class="truncate">{{selectedFarms?.length === 1 && !selectedFarms[0]?.id ? 'All Farms' : selectedFarms?.length + ' selected'}}</span>
        <span class="material-icons text-[18px] text-[var(--tertiary-text)]">expand_more</span>
      </div>
      <div *ngIf="showFarmDropdown" class="absolute top-[calc(100%+4px)] left-0 w-full bg-white rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[200] max-h-[200px] overflow-y-auto">
        <div *ngFor="let farm of farmList" (click)="toggleFarmSelection(farm)"
          class="py-2 px-3.5 text-[13px] font-medium cursor-pointer hover:bg-[var(--app-base,#F5F5F7)] flex items-center gap-2">
          <input type="checkbox" [checked]="isFarmSelected(farm)" class="w-3.5 h-3.5 accent-[var(--primary-dark)] pointer-events-none">
          <span>{{farm.name}}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Field Select -->
  <div class="mb-4">
    <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark,#49454F)] uppercase tracking-wide mb-1.5">Field</label>
    <div class="relative">
      <div (click)="showFieldDropdown = !showFieldDropdown; $event.stopPropagation()"
        class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border,#E8E8EC)] rounded-lg text-[13px] font-medium bg-white cursor-pointer flex items-center justify-between hover:border-[var(--primary-dark,#E2703A)] transition-all">
        <span class="truncate">{{selectedFields?.length === 1 && !selectedFields[0]?.fieldId ? 'All Fields' : selectedFields?.length + ' selected'}}</span>
        <span class="material-icons text-[18px] text-[var(--tertiary-text)]">expand_more</span>
      </div>
      <div *ngIf="showFieldDropdown" class="absolute top-[calc(100%+4px)] left-0 w-full bg-white rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[200] max-h-[200px] overflow-y-auto">
        <div *ngFor="let field of fieldList" (click)="toggleFieldSelection(field)"
          class="py-2 px-3.5 text-[13px] font-medium cursor-pointer hover:bg-[var(--app-base,#F5F5F7)] flex items-center gap-2">
          <input type="checkbox" [checked]="isFieldSelected(field)" class="w-3.5 h-3.5 accent-[var(--primary-dark)] pointer-events-none">
          <span>{{field.name}}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Pin Type Select -->
  <div class="mb-4">
    <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark,#49454F)] uppercase tracking-wide mb-1.5">Pin Type</label>
    <div class="relative">
      <div (click)="showPinTypeDropdown = !showPinTypeDropdown; $event.stopPropagation()"
        class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border,#E8E8EC)] rounded-lg text-[13px] font-medium bg-white cursor-pointer flex items-center justify-between hover:border-[var(--primary-dark,#E2703A)] transition-all">
        <span class="truncate">{{selectedPinTypes?.length === 1 && !selectedPinTypes[0]?.id ? 'All Pin Types' : selectedPinTypes?.length + ' selected'}}</span>
        <span class="material-icons text-[18px] text-[var(--tertiary-text)]">expand_more</span>
      </div>
      <div *ngIf="showPinTypeDropdown" class="absolute top-[calc(100%+4px)] left-0 w-full bg-white rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[200] max-h-[200px] overflow-y-auto">
        <div *ngFor="let pt of pinTypesList" (click)="togglePinTypeSelection(pt)"
          class="py-2 px-3.5 text-[13px] font-medium cursor-pointer hover:bg-[var(--app-base,#F5F5F7)] flex items-center gap-2">
          <input type="checkbox" [checked]="isPinTypeSelected(pt)" class="w-3.5 h-3.5 accent-[var(--primary-dark)] pointer-events-none">
          <span>{{pt.name}}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Date Range -->
  <div class="mb-6 flex gap-3">
    <div class="flex-1">
      <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark,#49454F)] uppercase tracking-wide mb-1.5">Start Date</label>
      <div class="relative">
        <input type="date" [formControl]="filterFromDate"
          class="w-full py-2.5 pl-3 pr-9 border-[1.5px] border-[var(--app-border,#E8E8EC)] rounded-lg text-[13px] font-medium bg-white outline-none cursor-pointer focus:border-[var(--primary-dark,#E2703A)] transition-all">
        <span class="material-icons absolute right-2.5 top-1/2 -translate-y-1/2 text-[18px] text-[var(--tertiary-text)] pointer-events-none">calendar_today</span>
      </div>
    </div>
    <div class="flex-1">
      <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark,#49454F)] uppercase tracking-wide mb-1.5">End Date</label>
      <div class="relative">
        <input type="date" [formControl]="filterToDate"
          class="w-full py-2.5 pl-3 pr-9 border-[1.5px] border-[var(--app-border,#E8E8EC)] rounded-lg text-[13px] font-medium bg-white outline-none cursor-pointer focus:border-[var(--primary-dark,#E2703A)] transition-all">
        <span class="material-icons absolute right-2.5 top-1/2 -translate-y-1/2 text-[18px] text-[var(--tertiary-text)] pointer-events-none">calendar_today</span>
      </div>
    </div>
  </div>

  <div class="flex justify-end gap-3 mt-4">
    <button (click)="cancelFilering()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>
    <button (click)="applyFilering()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition">Apply</button>
  </div>
</div>
